module.exports = __webpack_public_path__ + "img/NL481.76204ba7.png";